import React, { Component } from "react";
import { LayoutWithStepper } from "layouts";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import moment from "moment";
import {
  stepAction,
  applicantAction,
  submitClicked,
  submitInit,
  agreementAction,
} from "shared/store/actions";
import validation from "shared/validations";
import ReactLoading from "react-loading";

import {
  FooterAction,
  Accordion,
  AccordionGroup,
  PageContentWrapper,
} from "components";
import selectors from "shared/store/selectors";
import { PATH, APPLICANT_HISTORY_CODE } from "shared/constant";
import utils from "shared/helpers/utils";
import { isMobileOnly } from "react-device-detect";
import { Fatca, Crs } from "./contents";

let timeout = null;
// let source;
class FatcaCRS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      isLoading: false,
    };
    // source = new AbortController();
  }
  // state = {
  //   current: 0,
  //   isLoading: false,
  // }

  componentDidMount() {
    const {
      // onUpdateSteps, intl,
      onUpdateCurrentStep,
      isAllStepsCompleted,
      history,
    } = this.props;

    /** Redirect to Homepage if all steps are completed */
    if (isAllStepsCompleted) {
      history.push(PATH.HOME);
    } else {
      onUpdateCurrentStep("step4");
      // onUpdateSteps(intl);
    }
  }

  componentWillUnmount() {
    clearTimeout(timeout);

    // if (source) {
    //   // source.cancel('cancel lah!');
    //   source.abort();
    // }
  }

  onNext = (e) => {
    e.preventDefault();
    const {
      history,
      onSubmitClick,
      onSubmitInit,
      onSaveApplicant,
      intl,
      onUpdateSteps,
      onUpdateCurrentStep,
      onUpdateHistory,
      fatca: {
        fatcaQ1,
        fatcaQ2,
        fatcaQ2state,
        fatcaQ2city,
        fatcaQ3,
        fatcaQ3address,
        fatcaQ3usPhone,
        fatcaQ4,
        fatcaQ4address,
        fatcaQ5,
        fatcaQ5beneficiary,
        fatcaQ5nationality,
        fatcaQ6,
        fatcaQ6name,
        fatcaQ6nationality,
        fatcaQ6address,
        fatcaQ6usPhone,
      },
      crs: {
        crsQ1,
        crsQ2,
        crsQ3,
        crsQ4,
        crsQ5,
        crsQ6,
        residentOfReportableJurisdiction,
        residenceAddress,
        telephoneNumber,
        standingInstruction,
        holdMail,
        effectivePoa,
      },
      taxList,
      onUpdateTimestamp,
    } = this.props;
    const { current } = this.state;

    /** FATCA PAGE VALIDATION */
    const isFatcaValid = validation.fatcaSchema
      .fatcaPageSchema(
        intl,
        fatcaQ1,
        fatcaQ2,
        fatcaQ3,
        fatcaQ4,
        fatcaQ5,
        fatcaQ6,
      )
      .isValidSync({
        fatcaQ1,
        fatcaQ2,
        fatcaQ2state,
        fatcaQ2city,
        fatcaQ3,
        fatcaQ3address,
        fatcaQ3usPhone,
        fatcaQ4,
        fatcaQ4address,
        fatcaQ5,
        fatcaQ5beneficiary,
        fatcaQ5nationality,
        fatcaQ6,
        fatcaQ6name,
        fatcaQ6nationality,
        fatcaQ6address,
        fatcaQ6usPhone,
      });

    /** CRS Validation */
    const isCrsValid = validation.crsSchema
      .crsPageSchema(intl, crsQ1, crsQ2, crsQ3, crsQ4, crsQ5, crsQ6)
      .isValidSync({
        crsQ1,
        crsQ2,
        crsQ3,
        crsQ4,
        crsQ5,
        crsQ6,
        residentOfReportableJurisdiction,
        residenceAddress,
        telephoneNumber,
        standingInstruction,
        holdMail,
        effectivePoa,
      });

    /** Country Tax Validation */
    const isTaxListValid = validation.countryTaxSchema
      .countryTaxListSchema(intl, taxList)
      .isValidSync({ countryTax: taxList });

    // console.log('isFatcaValid', isFatcaValid);
    // console.log('isCrsValid', isCrsValid);
    // console.log('isTaxListValid ', isTaxListValid);

    /** @note update timestamp of AOF KYC doc as it is not rendering yet when saved in preview page */
    const timestamp = moment().unix();
    const timestampUTC = moment().utcOffset();
    onUpdateTimestamp(timestamp, timestampUTC);

    utils.scrollToError();

    switch (current) {
      case 0:
        onSubmitClick();
        if (isFatcaValid) {
          onSubmitInit();
          onSaveApplicant(false); // @note previously true which means to generate the PDF
          // ADDED: add history FACTA Questionnaires Step 4
          onUpdateHistory(
            APPLICANT_HISTORY_CODE.FATCA_QUES.code,
            APPLICANT_HISTORY_CODE.FATCA_QUES.codeI18n,
          );
          this.setState({ current: 1 });
        }
        break;
      case 1:
        onSubmitClick();
        if (isCrsValid && isTaxListValid) {
          onSubmitInit();
          onSaveApplicant(true).then((res) => {
            // ADDED: add history CRS Questionnaires Step 4
            onUpdateHistory(
              APPLICANT_HISTORY_CODE.CRS_QUES.code,
              APPLICANT_HISTORY_CODE.CRS_QUES.codeI18n,
            );
            onUpdateCurrentStep("step5");
            this.setState({ isLoading: true });

            /** delay for 5 secs (to give time for the back to update data on generated PDFs) */
            timeout = setTimeout(() => {
              if (res) {
                history.push(`${PATH.PREVIEW}/crm`);
                this.setState({ isLoading: false });
              }
            }, 10000);
          });
        }
        break;
      default:
        this.setState((prevState) => ({
          current: prevState.current,
        }));
        break;
    }
    onUpdateSteps(intl);
  };

  render() {
    const { intl, fatca, crs } = this.props;
    const { current, isLoading } = this.state;

    /** FATCA PAGE VALIDATION */
    const isFatcaValid = validation.fatcaSchema
      .fatcaPageSchema(
        intl,
        fatca.fatcaQ1,
        fatca.fatcaQ2,
        fatca.fatcaQ3,
        fatca.fatcaQ4,
        fatca.fatcaQ5,
        fatca.fatcaQ6,
      )
      .isValidSync({ ...fatca });

    const isCrsValid = validation.crsSchema
      .crsPageSchema(
        intl,
        crs.crsQ1,
        crs.crsQ2,
        crs.crsQ3,
        crs.crsQ4,
        crs.crsQ5,
        crs.crsQ6,
      )
      .isValidSync({ ...crs });

    const footer = (
      <FooterAction
        isSingleButton
        rightButton={
          isLoading ? (
            <ReactLoading
              height="24px"
              width="24px"
              color="#ffffff"
              type="spin"
            />
          ) : (
            intl.formatMessage({ id: "saveContinue" })
          )
        }
      />
    );

    return (
      <form onSubmit={this.onNext}>
        <PageContentWrapper isWithPadding isWithHeader>
          <div className="content-container">
            <AccordionGroup
              current={current}
              isValid={isFatcaValid && isCrsValid}
              onAccordionToggle={(e) => this.setState({ current: e })}
            >
              <Accordion
                isCompleted={isFatcaValid}
                level="I"
                title={intl.formatMessage({
                  id: "fatcaCrsQuestionnaires.fatca",
                })}
                content={<Fatca />}
              />
              <Accordion
                isCompleted={isCrsValid}
                level="II"
                title={intl.formatMessage({ id: "fatcaCrsQuestionnaires.crs" })}
                content={<Crs />}
              />
            </AccordionGroup>
          </div>
          {!isMobileOnly && footer}
        </PageContentWrapper>
        {isMobileOnly && footer}
      </form>
    );
  }
}

const mapStateToProps = (state) => ({
  fatca: selectors.getFatcaData(state),
  crs: selectors.getCrsData(state),
  taxList: selectors.getTaxList(state),
  isAllStepsCompleted: selectors.isAllStepsCompleted(state),
});

const mapDispatchToProps = (dispatch) => ({
  onUpdateCurrentStep: (currentStep) =>
    dispatch(stepAction.updateCurrentStep(currentStep)),
  onUpdateSteps: (intl) => dispatch(stepAction.updateSteps(intl)),
  onSaveApplicant: (isGenerate) =>
    dispatch(applicantAction.updateApplicant(isGenerate)),
  onUpdateHistory: (code, codeI18n) =>
    dispatch(applicantAction.updateHistory(code, codeI18n)),
  onUpdateTimestamp: (timestamp, timestampUTC) =>
    dispatch(
      agreementAction.updateAofKycProfileTimestamp(timestamp, timestampUTC),
    ),

  onSubmitClick: () => dispatch(submitClicked()),
  onSubmitInit: () => dispatch(submitInit()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LayoutWithStepper(injectIntl(FatcaCRS)));
